// @ts-nocheck

import { Block } from "@xprog/prensa"

import * as S from '../styles'

const CbnPageTeam = () => {
  return (
    <S.MainDiv>
      <S.Heading1>Expediente</S.Heading1>
      <Block css={S.logoProps}>
        <img src='/assets/cbn/logos/LogoCBNDesktop.svg' alt='Logo cbn Goiânia' height='102px' width='182px' />
      </Block>
      <Block css={S.topBlockProps}>
        <Block css={S.itemTopProps}>
          <S.Heading2>Coordenação de Jornalismo</S.Heading2>
          <S.Heading3>Luiz Geraldo</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>Chefia de Reportagem</S.Heading2>
          <S.Heading3>Aldenne Lopes</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>Apresentação CBN Goiânia</S.Heading2>
          <S.Heading3>Rayfran Cardoso</S.Heading3>
          <S.Heading3>Luiz Geraldo</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>Apresentação Tarde CBN</S.Heading2>
          <S.Heading3>Nathália Lima</S.Heading3>
          <S.Heading3>José Bonfim</S.Heading3>
        </Block>
      </Block> 
      <Block css={S.middleBlockProps}> 
        <Block css={S.itemTopProps}>
          <S.Heading2>Produção CBN Goiânia</S.Heading2>
          <S.Heading3>Andressa Vasconcelos</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>Produção Tarde CBN</S.Heading2>
          <S.Heading3>Joyce Vilela</S.Heading3>
          <S.Heading3>Bonny Fonseca Fonseca</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>Site CBN Goiânia</S.Heading2>
          <S.Heading3>João Paulo Alexandre</S.Heading3>
          <S.Heading3>Bonny Fonseca Fonseca</S.Heading3>
        </Block>
        <Block css={S.itemTopProps}>
          <S.Heading2>Reportagem</S.Heading2>
          <S.Heading3>Laís Araújo</S.Heading3>
          <S.Heading3>José Bonfim</S.Heading3>
          <S.Heading3>Daniela Versiane</S.Heading3>
          <S.Heading3>Alex Maia</S.Heading3>
        </Block>
      </Block>
    </S.MainDiv>
  )
}

export default CbnPageTeam
